import React from 'react'
import styled from 'styled-components'


import childthumb from '../asset/images/thumbsup.png'
import enfanttable from '../asset/images/tableenfant.png'
import fillequestion from '../asset/images/fillequestion.jpg'
import happychildren from '../asset/images/happychildren.png'


import abouticon2 from '../asset/images/about-icon-2.png'
import Subtitle from '../common/Subtitle/Subtitle'
import { H2, H2Courses } from '../common/H2/H2'
import H3 from '../common/H3/H3'
import { FigureAbout } from '../common/Figure/Figure'
import P from '../common/P/P'

const SectionAbout = styled.section`
padding-block: var(--section-padding);
`


function About() {
	return (
		<>
			<SectionAbout className="section about" id="about">
				<H2Courses>Concept</H2Courses>

					<div style={{ display:"flex", flexDirection:"column", marginLeft:"auto"}}>

					<P style={{ display:"flex",justifyContent:"center", padding:"0 10px", marginBlockEnd:"50px", textAlign:"justify-all"}}>

						<div style={{ width:"80%"}}>
						Avenir + est un organisme de perfectionnement scolaire pour les
						enfants de la maternelle au lycée.<br/><br/>

						<u>- Des cours en petit groupe :</u> Les élèves sont au maximum 5 par groupe de travail et bénéficient
						des enseignements de professeurs diplômés.<br/><br/>

						Des conditions de travail idéales sont posées grâce aux cours en petits groupes qui sont davantage stimulants que les cours individuels.
						En effet, l'observation des pairs est nettement plus riche et apporte différentes manières d'aborder la réflexion, notamment avec l'appui des professeurs qualifiés et bienveillants.<br/><br/>

						<u>- Des cours particuliers :</u> Vous pouvez opter pour des cours particuliers avec un professeur certifié recruté par le biais de notre organisme Avenir+.<br/><br/>
						
						Nous proposons des cours <u>sans engagement annuel</u>, selon les besoins de l'élève au cours de sa scolarité.<br/><br/>

						Vous avez la possibilité toutefois, de réserver un bloc de 5 cours, utilisables de façon discontinue selon les besoins durant l'année scolaire.<br/>

						Le système scolaire actuel manque de souplesse et pour le professeur en classe, aider les élèves au plus juste de leurs besoins est difficilement réalisable dans des classes aux effectifs très importants et aux niveaux tout autant hétérogènes.
						Les cours que nous proposons sont construits autour d'<u>une adaptation au plus près des besoins de l'enfant</u>.<br/><br/>
						Tous les professeurs recrutés sont diplômés CRPE, CAPES, disposent d'une expérience solide et travaillent dans les établissements scolaires de la région.
						</div>
					</P>

					</div>

				<div style={{ paddingTop: '50px' }} className="container">
					<FigureAbout>
						<img
							src={enfanttable}
							width="450"
							height="590"
							alt="groupe d'élève autour d'une table"
							className="w-100 about-img"
						/>

						<img
							src={childthumb}
							aria-hidden="true"
							alt="about1"
							className="abs-img abs-img-1"
						/>

						<img
							src={fillequestion}
							width="150"
							height="200"
							aria-hidden="true"
							alt="fille posant une question en classe"
							className="abs-img abs-img-2"
						/>
						<img
							src={happychildren}
							width="150"
							height="200"
							aria-hidden="true"
							alt="fille posant une question en classe"
							className="abs-img abs-img-3"
						/>

					</FigureAbout>

					<div className="about-content">
						<Subtitle>UN MEILLEUR AVENIR D'APPRENTISSAGE AVEC NOUS.</Subtitle>

						<H2 style={{ fontSize: '3.2rem' }}>
							Les enfants possèdent des capacités qui peuvent être développées
							dès le plus jeune âge.
						</H2>

						<ul className="about-list">
							<li className="about-item">
								<div className="item-icon item-icon-2">
									<img
										src={abouticon2}
										width="30"
										height="30"
										aria-hidden="true"
										alt="aboutico2"
									/>
								</div>

								<div>
									<H3 style={{ lineHeight: 1.6, marginBlockEnd: '5px' }}>
										Si votre enfant à besoin :
									</H3>

									<P
										style={{
											fontSize: '1.6rem',
											marginBlockEnd: '0px',
											lineHeight: 1.6,
										}}
									>
										- d'être <u><strong>rassuré</strong></u> en anticipant ou en révisant des notions
										vues en classe.
										<br />
										- d'être <u><strong>stimulé</strong></u> en allant au-delà du programme selon son
										rythme et ses capacités, avec d'autres élèves.
										<br />
										- d'être <u><strong>encadré</strong></u>  pour travailler régulièrement et pour
										apprendre à s'organiser
										<br />
										<br />
										{/* Avenir + aide votre enfant à maximiser son potentiel */}
										<u><strong>Avenir + s'engage donc pour les enfants :</strong></u> en difficulté - qui manquent de confiance en eux - qui ne trouvent pas de stimulation à la hauteur de leurs capacités

										Nos cours s'adressent aux élèves ayant une difficulté, mais pas uniquement car nous pensons que bien des élèves ont besoin de prendre confiance en eux.
										Ainsi, découvrir en amont parfois les notions qui vont être abordées en classe peut les rassurer.

 										Les élèves qui développent des facilités dans certains domaines ne doivent pas non plus être freinés par le rythme du groupe classe et nous leur donnons la possibilité, chez avenir+, de poursuivre leur perfectionnement.
										 <br />
										<br />
										Les professeurs préparent <u>un bilan</u> régulièrement afin que les parents suivent l'évolution du travail de leur enfant.
										L'équipe pédagogique et les parents se concertent pour adapter l'orientation de l'élève dans un cours de niveau plus simple ou au contraire plus avancé si nécessaire. 
									</P>
									<br/>
									<P style={{ fontSize: '1.6rem' }}>
										Afin de proposer un cadre studieux et serein, les élèves
										doivent être volontaires et adopter un comportement
										irréprochable
										<br />
									</P>
								</div>
							</li>

						</ul>

					</div>
				</div>
			</SectionAbout>
		</>
	)
}

export default About
